import { render, staticRenderFns } from "./Fitness.vue?vue&type=template&id=412eea70&"
import script from "./Fitness.vue?vue&type=script&lang=js&"
export * from "./Fitness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports